import http from "../../Services/Auth/config/http-common";
import IAuth from "../../Interfaces/Auth/IAuth"
//import ItemMenuData  from "../../Interfaces/Auth/IMenu";
import IPermisos from "../../Interfaces/Auth/IPermisos";
import IRespuesta from "../../Interfaces/Respuestas/IRespuesta";

class authDataService {
  async login(data: IAuth) {
    return await http.post<IPermisos>("Auth/Login", data);
  }
  async Validate() {
    return await http.get<String>("Auth/Validate");
  }
  ResetPassword(data: IAuth) {
    return http.post<IRespuesta>(`Auth/ResetPassword`, data);
  }
}
export default new authDataService();